
export class DataCollectionStepByStepChecklist {
  public id: string;
  public groups: DataCollectionStepBtStepGroup[];
}

export class DataCollectionStepBtStepGroup {
  public title: string;
  public notes: DataCollectionNote[];
  public steps: DataCollectionStep[];
  public isExpanded: boolean = false;
}

export class DataCollectionStep {
  public text: string;
  public note: DataCollectionNote;
  public isHeading: boolean = false;
}

export class DataCollectionNote {
  public text: string;
  public position: DataCollectionNotePosition;
}

export enum DataCollectionNotePosition {
  Top  = 'TOP',
  Bottom = 'BOTTOM'
}
